import React from 'react';
import PropTypes from 'prop-types';
import Lightbox from '../lightbox/lightbox';
import { FSFMotoLightBoxHeader } from './fsf_moto_light_box_header';
import { FSFMotoLightBoxContent } from './fsf_moto_light_box_content';

function FSFMotoLightBox(props) {
    return (
        <Lightbox
            opened={props.visible}
            onClose={props.onClose}
            additionalClassNames={['fsf-moto-light-box__lightbox']}
        >
            <div className="fsf-moto-light-box">
                <FSFMotoLightBoxHeader />
                <FSFMotoLightBoxContent />
            </div>
        </Lightbox>
    );
}

FSFMotoLightBox.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export { FSFMotoLightBox };
